import { render, staticRenderFns } from "./advanceCollectionReport.vue?vue&type=template&id=4fba8c81"
import script from "./advanceCollectionReport.vue?vue&type=script&lang=js"
export * from "./advanceCollectionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports